/**
 * Dev.ts
 * @author Diao Zheng
 * @file External development flags
 * @barrel export all
 */
let inDevMode = false;
export function setDevMode(mode) {
    inDevMode = mode;
}
export function devOnly(thunk, ...args) {
    if (inDevMode) {
        thunk(...args);
    }
}
export function select(devMode, prodMode, ...args) {
    if (inDevMode) {
        return devMode(...args);
    }
    return prodMode(...args);
}
// set default dev modes
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
if (global.__DEV__ !== undefined) {
    // in React Native, we use React's defined __DEV__ value
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    setDevMode(global.__DEV__);
}
else if (process.env.NODE_ENV) {
    // in NodeJS, we use Node's environment variable
    setDevMode(!/^prod.*$/i.exec(process.env.NODE_ENV));
}
